/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import Guard from "../../guard";
import { PropertyDataType, TypeInfo } from "./data-type";
import { IMember, MemberBase } from "./member";
import { MemberDefinitionType } from "./member-definition-type";

export interface IProperty extends IMember {
    readonly dataType: PropertyDataType | unknown;
    readonly isMultiLanguage: boolean;
    readonly hasDataSource: boolean;
}

export abstract class PropertyBase<T extends PropertyDataType | unknown, B extends boolean>
    extends MemberBase
    implements IProperty
{
    readonly dataType: T | unknown;
    readonly isMultiValue: B;
    readonly isMultiLanguage: boolean = false;
    readonly hasDataSource: boolean;

    protected constructor(name: string, typeInfo: TypeInfo<T, B>, hasDataSource: boolean = false) {
        super(name, MemberDefinitionType.Property);
        Guard.notNullOrUndefined(typeInfo);

        this.dataType = typeInfo.type;
        this.isMultiValue = typeInfo.isArray;
        this.hasDataSource = hasDataSource;
    }

    protected abstract getTypeName(): string;

    /**
     * Returns a string representation of the current property instance.
     *
     * @remarks
     * Can not be used for serialization. Only useful during debugging or testing.
     * Returned format: \<member format ({@link MemberBase.toString})\> ({@link PropertyDataType})
     */
    toString(): string {
        return `${super.toString()} (${PropertyDataType[this.dataType as PropertyDataType]})`;
    }
}
